import React, { useState } from "react";

import { Container, Row, Col, Form, Alert } from "react-bootstrap";

//Components
import TopMargin from "../components/TopMargin";
import RowMargin from "../components/RowMargin";
import Loading from "../components/Loading";
import SuperAppButton from "../components/SuperAppButton";
import { fetchSecure } from "../utils/utils";

// Put this above `export default function UploadFileForImages(...)` or inside it (before handleSubmit)
const parseResponseSafely = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  const text = await response.text(); // always read as text first
  let json = null;

  // Try to parse JSON only if content-type hints it's JSON OR if parsing succeeds
  if (contentType.includes("application/json")) {
    try {
      json = JSON.parse(text);
    } catch (_) {}
  } else {
    try {
      json = JSON.parse(text);
    } catch (_) {}
  }

  return { text, json };
};

export default function UploadFileForImages(props) {
  console.log("🚀 ~ UploadFileForImages ~ props:", props);
  const [fileName, setFileName] = useState(props.fileName || null);
  const [fileNames, setFileNames] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [videoProgress, setVideoProgress] = useState(0);
  const [formData, setFormData] = useState({
    data: {},
    status: "IDLE",
    errorMessage: "",
  });
  let allData = props?.allData;
  const isBlog = props?.isBlog || false;
  console.log("PopupGallery :UploadFileForImages: isBlog", isBlog);

  const resetFileInput = () => {
    let randomString = Math.random().toString(36);
    setFileInputKey(randomString);
  };

  const handleInputChange = (e) => {
    const target = e.currentTarget;
    const localFileNames = [];
    let value;
    switch (target.type) {
      case "checkbox":
        value = target.checked;
        break;
      case "file":
        //value = e.target.files[0];
        value = e.target.files;
        for (let x = 0; x < value.length; x++) {
          console.log("File Name = " + value[x].name);
          console.log("File Prefix = " + props.filePrefix);
          localFileNames.push(props.filePrefix + value[x].name);
        }
        console.log("files = " + JSON.stringify(localFileNames));
        setFileNames(localFileNames);
        console.log("file value = " + JSON.stringify(value));
        break;
      default:
        value = target.value;
        break;
    }
    const name = target.name;
    console.log(target);
    console.log(props.filePrefix);
    console.log(name);
    if (props.filePrefix && name === "fileName") {
      console.log("IN HERE - " + props.filePrefix + value.name);
      setFileName(props.filePrefix + value.name);
    }
    setFormData({
      data: { ...formData.data, [name]: value },
      status: "IDLE",
    });
  };

  const handleSubmit = async () => {
    try {
      setFormData((prev) => ({
        ...prev,
        status: "SUBMITTED",
        errorMessage: "",
      }));

      // Build form-data for legacy/image paths
      const uploadData = new FormData();
      Object.keys(formData.data).forEach((key) => {
        const val = formData.data[key];
        if (key === "fileName" && val && val.length) {
          for (let x = 0; x < val.length; x++) {
            uploadData.append(`${key}-${x}`, val[x], fileNames[x]);
          }
        } else {
          uploadData.append(key, val);
        }
      });
      uploadData.append("id", props.id);
      uploadData.append("userId", props.user_id);

      // ---------- FAST PATH: BLOG VIDEO ----------
      if (isBlog && props.allowVideo) {
        const file = formData.data.fileName?.[0];
        if (!file) {
          setFormData((prev) => ({
            ...prev,
            status: "ERROR",
            errorMessage: "No video selected",
          }));
          return;
        }

        // 1) Get signed URL
        const suResp = await fetchSecure("/api/getBlogSignedUrl", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: props.id, // folder (userDeep.id)
            fileName: file.name,
            contentType: file.type || "video/mp4",
          }),
        });
        const suData = await suResp.json();
        if (!suResp.ok || !suData.success || !suData.signedUrl) {
          throw new Error(suData.error || "Failed to get signed URL");
        }

        // 2) Direct PUT to GCS
        await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open("PUT", suData.signedUrl, true);
          xhr.setRequestHeader("Content-Type", file.type || "video/mp4");
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              setVideoProgress(Math.round((evt.loaded * 100) / evt.total));
            }
          };
          xhr.onload = () =>
            xhr.status >= 200 && xhr.status < 300
              ? resolve()
              : reject(new Error(`Upload failed: ${xhr.status}`));
          xhr.onerror = () => reject(new Error("Network error during upload"));
          xhr.send(file);
        });

        // 3) Refresh & success UI
        if (props.callback) await props.callback();
        setFormData({
          data: { message: "Upload successful" },
          status: "SUCCESS",
          errorMessage: "",
        });
        setVideoProgress(0);
        resetFileInput();
        return; // IMPORTANT: do not continue into legacy parsing
      }

      // ---------- LEGACY / IMAGE PATHS ----------
      // Blog images: /api/uploadFileForBlog
      // Legacy (non-blog): /api/uploadForImages
      let uploadUrl = "/api/uploadForImages";
      if (isBlog) uploadUrl = "/api/uploadFileForBlog";

      const response = await fetchSecure(uploadUrl, {
        method: "POST",
        body: uploadData,
      });

      // parse safely (works whether server returns text or JSON)
      const { text, json } = await parseResponseSafely(response);

      if (response.ok) {
        const data = json ?? { message: text || "Upload successful" };
        setFormData({ data, status: "SUCCESS", errorMessage: "" });

        resetFileInput();

        // small delay so the new file shows up in list
        await new Promise((r) => setTimeout(r, 4000));
        if (props.callback) await props.callback();
      } else {
        const errMsg =
          (json && (json.message || json.error || json.detail)) ||
          (text && text.trim()) ||
          `${response.status} ${response.statusText}`;

        setFormData({
          data: json || {},
          status: "ERROR",
          errorMessage: errMsg,
        });
      }
    } catch (e) {
      console.error("Upload error:", e);
      setFormData((prev) => ({
        ...prev,
        status: "ERROR",
        errorMessage: e?.message || "Unexpected error while uploading.",
      }));
    }
  };

  // console.log(
  //   "Props :: upload file images :: props?.allData ::",
  //   props?.allData.data
  // );

  return (
    <Container>
      <Row>
        <Col>
          <TopMargin />
          <Form className="XXX" style={{ marginBottom: "20px" }}>
            <Form.Group controlId="uploadFile">
              <Form.Label style={{ color: "#fff" }}>
                {props.allowVideo
                  ? "Upload Video File"
                  : "Upload Image File(s)"}
              </Form.Label>
              <Form.Control
                key={fileInputKey}
                type="file"
                name="fileName"
                placeholder="Select a file or files"
                className="form-control"
                onChange={handleInputChange}
                // accept="pdf"
                // multiple
                // style={{
                //   height: "38px",
                // }}
                accept={props.allowVideo ? "video/*" : "image/*"} // 👈 switch
                multiple={!props.allowVideo} // 👈 only 1 video allowed
                style={{ height: "38px" }}
              />
            </Form.Group>
            <Form.Group></Form.Group>
            <RowMargin />
            <SuperAppButton
              variant="primary"
              type="button"
              onClick={handleSubmit}
              disabled={fileNames.length === 0}
            >
              Upload
            </SuperAppButton>
            &nbsp;
          </Form>
        </Col>
      </Row>
      {formData.status === "SUBMITTED" && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Loading />
            </Col>
          </Row>
        </React.Fragment>
      )}
      {props.allowVideo && videoProgress > 0 && videoProgress < 100 && (
        <div style={{ marginTop: 12 }}>
          <div style={{ color: "#fff", marginBottom: 6 }}>
            Uploading… {videoProgress}%
          </div>
          <div style={{ height: 6, background: "rgba(255,255,255,0.2)" }}>
            <div
              style={{
                height: "100%",
                width: `${videoProgress}%`,
                background: "#5139FF",
              }}
            />
          </div>
        </div>
      )}
      {formData.status === "ERROR" && (
        <>
          <RowMargin />
          <Row>
            <Col>
              <Alert variant="danger">
                {/* Prefer explicit errorMessage; fall back to server JSON keys or default */}
                {formData.errorMessage ||
                  (formData.data &&
                    (formData.data.message ||
                      formData.data.error ||
                      formData.data.detail)) ||
                  "Failed to upload file, please try again"}
              </Alert>
            </Col>
          </Row>
        </>
      )}

      {formData.status === "SUCCESS" && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Alert variant="success">
                {formData.data && "message" in formData.data
                  ? formData.data.message
                  : "Successfully uploaded file!"}
              </Alert>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Container>
  );
}

/* used to have a cancel button..but not sure it makes much sense
            <Button variant="primary" type="button" onClick={props.handleUploadFileCancel}>
              Cancel
            </Button>
*/
